import { useLoaderData, useRouteLoaderData } from 'react-router';
import { BillingAccountDetails } from '../../../../../components/BillingAccountDetails/BillingAccountDetails.js';
import type { BillingAccountLoaderResponse } from '../../../../../common/loaders.js';
import type { BillingAccount } from '../../../../../generated/api/billingAccount.js';

export const BillingAccountPath = () => {
  const billingAccount = useRouteLoaderData('baRoot') as BillingAccount;
  const { billChannels, contacts } = useLoaderData() as BillingAccountLoaderResponse;

  return <BillingAccountDetails billingAccount={billingAccount} billChannels={billChannels} contacts={contacts} />;
};
